import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { tryCatchHandler } from '../../base/decorators';
import { isValidEncId } from '../../base/utils/check';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import { FileDesc } from '../entity/file-desc';
import { FileMetaEntity } from '../entity/file-meta';
import { FileDescRepo } from '../repository/file-desc-repository';
import { FileMetaRepo } from '../repository/file-meta-repository';
import { FileOperationRepo } from '../repository/file-operation-repository';
var FileInfoDomainService = /** @class */ (function () {
    function FileInfoDomainService(docMetaDomain) {
        this.docMetaDomain = docMetaDomain;
        this.fileDescRepo = new FileDescRepo();
        this.fileMetaRepo = new FileMetaRepo();
        this.fileOperationRepo = new FileOperationRepo();
        this.fileDescEntity = new FileDesc(this.fileDescRepo /* , FILE_DESC_ENTITY_UUID */);
        this.fileMetaEntity = new FileMetaEntity(this.fileMetaRepo /* , FILE_META_ENTITY_UUID */);
        if (window.basicClientVars) {
            this.initWithBasicClientVars(window.basicClientVars);
        }
    }
    /**
     * 初始化 FileInfo 领域
     * 无需初始化，提供空实现
     */
    FileInfoDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            var docId, addRecent, resData;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        docId = requestParam.docId, addRecent = requestParam.addRecent;
                        if (!isValidEncId(docId))
                            return [2 /*return*/];
                        // 初始化 docMetaDomain
                        return [4 /*yield*/, this.docMetaDomain.init(requestParam)];
                    case 1:
                        // 初始化 docMetaDomain
                        _c.sent();
                        return [4 /*yield*/, this.docMetaDomain.docMetaEntity.fetchFileInfo(docId, addRecent)];
                    case 2:
                        resData = (_c.sent()).resData;
                        if ((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 && ((_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.result)) {
                            this.fileMetaEntity.initWithFileInfoRsp(resData.data.result);
                            this.initFileDescEntity((_b = resData.data.result.fileMeta) === null || _b === void 0 ? void 0 : _b.fileId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated
     * FIXME: 这个 fileDescEntity 看起来没有存在的必要
     * 1、没有看到使用的地方
     * 2、过于简单，是否有抽象为一个独立的 entity 的必要
     * 3、size 在 fileMeta 中已经存在，不知道为什么要另外去请求 fileDesc cgi 获取
     */
    FileInfoDomainService.prototype.initFileDescEntity = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!fileId)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.fileDescEntity.fetchFileDesc(fileId)];
                    case 1:
                        resData = (_c.sent()).resData;
                        if ((_b = (_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.size) {
                            this.fileDescEntity.init({
                                accurateSize: resData.data.result.size,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 启动时用 window.basicClientVars 初始化.
     * 此操作理论上只做一次，后续更新都是通过user-info cgi拉取到的
     * @param basicClientVars window.basicClientVars
     */
    FileInfoDomainService.prototype.initWithBasicClientVars = function (basicClientVars) {
        var _a, _b, _c, _d;
        // drive 文件才有 cosInfo
        if ((_a = basicClientVars === null || basicClientVars === void 0 ? void 0 : basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.cosInfo) {
            this.fileMetaEntity.ext = (_c = (_b = basicClientVars === null || basicClientVars === void 0 ? void 0 : basicClientVars.docInfo) === null || _b === void 0 ? void 0 : _b.cosInfo) === null || _c === void 0 ? void 0 : _c.driveExt;
            this.fileMetaEntity.cosInfo = (_d = basicClientVars === null || basicClientVars === void 0 ? void 0 : basicClientVars.docInfo) === null || _d === void 0 ? void 0 : _d.cosInfo;
        }
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FileInfoDomainService.prototype, "init", null);
    __decorate([
        tryCatchHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FileInfoDomainService.prototype, "initWithBasicClientVars", null);
    FileInfoDomainService = __decorate([
        __param(0, IDocMetaDomainService),
        __metadata("design:paramtypes", [Object])
    ], FileInfoDomainService);
    return FileInfoDomainService;
}());
export { FileInfoDomainService };
